// @flow

import React from 'react';
import { Typography, Grid } from '@material-ui/core/';
import APIDocscontent from '../../../data/cms/content/api-docs';
import APIContent from '../../../components/apiproducts/docs/content';
import SampleCode from '../../../components/apiproducts/docs/samplecode';
import XmlPath from '../../../components/docs/docs-version';
import NamingConvertion from '../../../components/apiproducts/docs/namingconvertion';
import InputParameter from '../../../components/apiproducts/docs/input';
import Constraints from '../../../components/apiproducts/docs/Constraints';
import Header from '../../../components/apiproducts/docs/header';
import Information from '../../../components/apiproducts/docs/information';
import ErrorCode from '../../../components/apiproducts/docs/errorcode';
import {
    LookupBreadCrumb,
    Authentication,
    ListsBreadCrumb,
} from '../../../components/docs/docs-version/breadcrum';
import BreadCrumb from '../../../components/docs/docs-version/breadcrum';

import './style.css';
type Props = {
    PageName: Object,
    BreadCumVersionLookupclick: Function,
    BreadCumVersionActionclick: Function,
    BreadCumVersionAuthclick: Function,
    BreadCumVersionListsclick: Function,
};
function DocsVerison(props: Props) {
    const {
        PageName,
        BreadCumVersionLookupclick,
        BreadCumVersionActionclick,
        BreadCumVersionAuthclick,
        BreadCumVersionListsclick,
    } = props;
    const page = PageName;
    const [GetAPIDocs, setAPIDocsContent] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const APIName = XmlPath(page);
    var Category = APIName.ApiType;
    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await APIDocscontent(APIName);
            setAPIDocsContent(fetchedContent);
            setLoading(false);
            window.scrollTo(0, 0);
        };
        fetchContent();
    }, [APIName]);

    return (
        <Grid container className="docs-verison">
            <Grid item sm={12} md={12} lg={12}>
                {!loading ? (
                    <>
                        <Grid className="docs-verison-breadcumb">
                            {Category === 'Lookup Methods' ? (
                                <LookupBreadCrumb
                                    onBreadCumLookupclick={
                                        BreadCumVersionLookupclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'Authentication' ? (
                                <Authentication
                                    onBreadCumAuthclick={
                                        BreadCumVersionAuthclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : Category === 'Lists' ? (
                                <ListsBreadCrumb
                                    onBreadCumListsclick={
                                        BreadCumVersionListsclick
                                    }
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            ) : (
                                <BreadCrumb
                                    onBreadcumClick={BreadCumVersionActionclick}
                                    title={GetAPIDocs.ApiHelp.Info.Title}
                                />
                            )}
                        </Grid>
                        <Typography
                            component="div"
                            id={GetAPIDocs.ApiHelp.Info.RefName}
                        >
                            <Typography component="h3">
                                {GetAPIDocs.ApiHelp.Category}
                            </Typography>

                            <Typography component="h5">
                                {GetAPIDocs.ApiHelp.Info.Title}
                            </Typography>
                            <APIContent
                                Content={GetAPIDocs.ApiHelp.Info.Contents}
                            />
                        </Typography>
                        {GetAPIDocs.ApiHelp.NamingConvertion === '' ? (
                            ''
                        ) : (
                            <NamingConvertion
                                Content={GetAPIDocs.ApiHelp.NamingConvertion}
                            />
                        )}
                        <Typography
                            component="div"
                            id={GetAPIDocs.ApiHelp.Endpoint.RefName}
                        >
                            <Typography component="h5">
                                {GetAPIDocs.ApiHelp.Endpoint.Title}
                            </Typography>
                            <Typography
                                component="div"
                                className="docs-verison-code"
                            >
                                {GetAPIDocs.ApiHelp.Endpoint.Content}
                            </Typography>
                        </Typography>
                        <InputParameter
                            Content={GetAPIDocs.ApiHelp.InputParameters}
                        />
                        {GetAPIDocs.ApiHelp.Constraints === '' ? (
                            ''
                        ) : (
                            <Constraints
                                Content={GetAPIDocs.ApiHelp.Constraints}
                            />
                        )}
                        <Typography
                            component="div"
                            id={GetAPIDocs.ApiHelp.Header.RefName}
                        >
                            <Header Content={GetAPIDocs.ApiHelp.Header} />

                            {GetAPIDocs.ApiHelp.TaxInfo === '' ? (
                                ''
                            ) : (
                                <APIContent
                                    Content={
                                        GetAPIDocs.ApiHelp.TaxInfo.Contents
                                    }
                                />
                            )}
                            {GetAPIDocs.ApiHelp.LeadsInfo === '' ? (
                                ''
                            ) : (
                                <APIContent
                                    Content={
                                        GetAPIDocs.ApiHelp.LeadsInfo.Contents
                                    }
                                />
                            )}

                            {GetAPIDocs.ApiHelp.Information === '' ? (
                                ''
                            ) : (
                                <Information
                                    Content={GetAPIDocs.ApiHelp.Information}
                                />
                            )}
                        </Typography>
                        {GetAPIDocs.ApiHelp.ErrorCode === '' ? (
                            ''
                        ) : (
                            <ErrorCode Content={GetAPIDocs.ApiHelp.ErrorCode} />
                        )}

                        {GetAPIDocs.ApiHelp.SampleCode === '' ? (
                            ''
                        ) : (
                            <>
                                <Typography
                                    component="div"
                                    id={GetAPIDocs.ApiHelp.SampleCode.RefName}
                                >
                                    <Typography
                                        id={
                                            GetAPIDocs.ApiHelp.SampleCode
                                                .RefName
                                        }
                                        component="h5"
                                    >Sample Code</Typography>

                                    <SampleCode
                                        Content={GetAPIDocs.ApiHelp.SampleCode}
                                    />
                                </Typography>
                            </>
                        )}
                    </>
                ) : (
                    ''
                )}
            </Grid>
        </Grid>
    );
}

export default DocsVerison;
